"use strict";
/* tslint:disable */
var TComboNoCombinationSingleSPSlipMode = {
// this is the stub for the template required by the WebSite
};
window.TComboNoCombinationSingleSPSlipMode = TComboNoCombinationSingleSPSlipMode;
//# sourceMappingURL=TComboNoCombinationSingleSPSlipMode.js.map